import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { InstallPrompt } from "@/components/InstallPrompt";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import PublicBincard from "@/pages/PublicBincard";
import VerifikasiSPL from "@/pages/VerifikasiSPL";
import VerifikasiCuti from "@/pages/VerifikasiCuti";
import LiveStockMonitor from "@/pages/LiveStockMonitor";
import LiveMonitorGabungan from "@/pages/LiveMonitorGabungan";
import { Toaster } from "@/components/ui/sonner";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="auth-loading">
        <div className="h-10 w-10 rounded-full border-4 border-blue-600 border-t-transparent animate-spin" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/bincard/:id" element={<PublicBincard />} />
      <Route path="/verifikasi-spl/:id/:token" element={<VerifikasiSPL />} />
      <Route path="/verifikasi-spl/:id" element={<VerifikasiSPL />} />
      <Route path="/verifikasi-cuti/:id/:token" element={<VerifikasiCuti />} />
      <Route path="/verifikasi-cuti/:id" element={<VerifikasiCuti />} />
      <Route path="/live-stock" element={<ProtectedRoute><LiveStockMonitor /></ProtectedRoute>} />
      <Route path="/live-monitor" element={<ProtectedRoute><LiveMonitorGabungan /></ProtectedRoute>} />
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/*" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="top-right" richColors />
          <InstallPrompt />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
